import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const Projects = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

const ProjectsDetail = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/detail.vue')

const ProjectsBudgets = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/budgets.vue')

export const projectsModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/projects',
    name: 'projects',
    component: Projects,
    meta: {
      title: 'Proyectos',
      auth: {
        roles: Object.values(authRoles),
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: '/projects/:id/details',
    name: 'projectsDetails',
    component: ProjectsDetail,
    meta: {
      title: 'Gestionar Proyectos',
      auth: {
        roles: Object.values(authRoles),
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: '/projects/:id/budgets',
    name: 'projectsBudgets',
    component: ProjectsBudgets,
    meta: {
      title: 'Gestionar Presupuestos',
      auth: {
        roles: Object.values(authRoles),
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
